import { Injectable, inject } from '@angular/core';
import { Location } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';

const MAX_HISTORY = 50;

@Injectable({
  providedIn: 'root',
})
export class NavigationHistoryService {
  private router = inject(Router);
  private location = inject(Location);
  private stack: string[] = [];
  private navigatingBack = false;

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => this.onNavigationEnd(event.urlAfterRedirects));
  }

  goBack(fallback: readonly string[]): void {
    if (this.navigatingBack) {
      return;
    }

    if (this.stack.length >= 2) {
      this.navigatingBack = true;
      this.stack.pop();
      this.location.back();
      return;
    }

    void this.router.navigate([...fallback]);
  }

  private onNavigationEnd(url: string): void {
    const normalized = this.normalize(url);

    if (this.navigatingBack) {
      this.navigatingBack = false;
      const last = this.stack[this.stack.length - 1];
      if (last !== normalized) {
        if (this.stack.length > 0) {
          this.stack[this.stack.length - 1] = normalized;
        } else {
          this.stack.push(normalized);
        }
      }
      return;
    }

    if (this.stack[this.stack.length - 1] === normalized) {
      return;
    }

    this.stack.push(normalized);
    if (this.stack.length > MAX_HISTORY) {
      this.stack.shift();
    }
  }

  private normalize(url: string): string {
    if (!url || url === '/') {
      return url || '/';
    }
    return url.length > 1 && url.endsWith('/') ? url.slice(0, -1) : url;
  }
}
